<div class="p-6 text-center">
  <div class="mb-4 flex justify-center">
    <img src="assets/images/warning.svg" alt="" class="h-14 w-14" aria-hidden="true" />
  </div>
  <h2 class="mb-3 text-xl font-semibold text-neutral-gray70">
    {{ 'onboarding.blocked.title' | translate }}
  </h2>
  <p class="mb-6 text-sm leading-relaxed text-neutral-gray60">
    {{ 'onboarding.blocked.message' | translate }}
  </p>
  <div class="flex justify-center gap-3">
    <button
      type="button"
      (click)="close()"
      class="rounded-lg border border-neutral-gray30 px-5 py-2.5 text-sm font-medium text-neutral-gray70 transition hover:bg-neutral-gray10 focus:outline-none">
      {{ 'shared.actions.buttons.cancel' | translate }}
    </button>
    <button
      type="button"
      (click)="openSalesContact()"
      class="rounded-lg bg-primary-90 px-5 py-2.5 text-sm font-medium text-neutral-white transition hover:bg-primary-70 focus:outline-none">
      {{ 'onboarding.blocked.ctaLabel' | translate }}
    </button>
  </div>
</div>

<app-sales-contact-modal
  [visible]="showSalesContact"
  (closed)="onSalesClosed()"
  (submitted)="onSalesSubmitted()"></app-sales-contact-modal>
